let ctx;
const KEY = "jp_admin_sound";

export const soundEnabled = () => localStorage.getItem(KEY) !== "off";
export const setSoundEnabled = (on) => localStorage.setItem(KEY, on ? "on" : "off");

export const unlockAudio = () => {
  ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
};

const PATTERNS = {
  topup: [[880, 0], [1320, 0.16]],
  bongkar: [[520, 0], [390, 0.18], [520, 0.36]],
};

export const playAlert = (kind) => {
  if (!soundEnabled()) return;
  try {
    unlockAudio();
    PATTERNS[kind].forEach(([freq, at]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = kind === "topup" ? "sine" : "triangle";
      osc.frequency.value = freq;
      const t = ctx.currentTime + at;
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.35, t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.15);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t);
      osc.stop(t + 0.16);
    });
  } catch {
    /* audio unavailable */
  }
};
